import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "content-wrap flex flex-between" }
const _hoisted_3 = {
  class: "logo",
  href: "/"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "logo"
}
const _hoisted_5 = { class: "school-name" }
const _hoisted_6 = { class: "menu" }
const _hoisted_7 = { class: "userInfo" }

import { useUserStore } from "@/store";
import { computed } from "vue";
import { useRouter } from "vue-router";
import { request } from "@/services";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainHeader',
  props: {
  parent: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const router = useRouter();
const userStore = useUserStore();
const props = __props;
const auth = computed(() => {
  /**
   *  1.当响应的用户角色(type)==0 && 角色权限(customRole)==null  只显示网上阅卷模块  此时用户的角色为普通老师
      2.当响应的用户角色(type)==0 && 角色权限(customRole)!=null  只显示网上阅卷+考试管理模块  此时用户的角色为普通老师，但管理员给与给老师自定义角色权限
      3.当响应的用户角色(type)==1  显示网上阅卷+考试管理+系统设置模块  此时用户的角色为学校管理员
   */
  if (userStore.userInfo.type == 1) {
    return 3;
  } else if (userStore.userInfo.type == 0 && userStore.userInfo.customRole == null) {
    return 1;
  } else {
    return 2;
  }
});
const logout = () => {
  userStore.logout();
  // 跳转到登录页面
  router.replace({ name: "Login" });
};
const handleButtonClick = async () => {
  request.get("/common/open-app", { params: { type: 2, scoreType: 3 } }).then((res) => {
    if (res.code === 200) {
      window.open(res.data, "_blank");
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", _hoisted_3, [
        (_unref(userStore).userInfo.source === 0 && !_unref(userStore).userInfo.ico && _unref(userStore).userInfo.schoolId !== 530243)
          ? (_openBlock(), _createElementBlock("img", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(userStore).userInfo.schoolId !== 530243 ? _unref(userStore).userInfo.schoolName : ''), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (auth.value !== 1)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              class: _normalizeClass(["menu-item", { 'router-link-exact-active': props.parent == 'Task' }]),
              to: "/task"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("考试管理")
              ])),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true),
        _createVNode(_component_router_link, {
          class: _normalizeClass(["menu-item", { 'router-link-exact-active': props.parent == 'OnlineCheck' }]),
          to: "/onlineCheck"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode("网上阅卷")
          ])),
          _: 1
        }, 8, ["class"]),
        _createElementVNode("a", {
          class: "menu-item",
          onClick: handleButtonClick
        }, "学业评价"),
        (auth.value === 3)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 1,
              class: _normalizeClass(["menu-item", { 'router-link-exact-active': props.parent == 'System' }]),
              to: "/system"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("系统设置")
              ])),
              _: 1
            }, 8, ["class"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createTextVNode(_toDisplayString(_unref(userStore).userInfo.name) + " ", 1),
        _withDirectives(_createElementVNode("span", {
          class: "ml10 text-white pointer",
          onClick: logout
        }, "退出", 512), [
          [_vShow, _unref(userStore).userInfo.source === 0 && !_unref(userStore).userInfo.ico]
        ])
      ])
    ])
  ]))
}
}

})